"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global Error:", error);
  }, [error]);

  return (
    <html>
      <body
        style={{
          padding: "40px",
          fontFamily: "system-ui, -apple-system, sans-serif",
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        <h1 style={{ color: "#dc2626", marginBottom: "16px" }}>
          Si è verificato un errore
        </h1>
        <p style={{ marginBottom: "8px" }}>
          <strong>Messaggio:</strong> {error.message || "Errore sconosciuto"}
        </p>
        {error.digest && (
          <p style={{ marginBottom: "8px", color: "#6b7280" }}>
            <strong>Error ID:</strong> {error.digest}
          </p>
        )}
        {error.name && (
          <p style={{ marginBottom: "16px", color: "#6b7280" }}>
            <strong>Tipo:</strong> {error.name}
          </p>
        )}
        {error.stack && (
          <details style={{ marginBottom: "16px" }}>
            <summary
              style={{
                cursor: "pointer",
                fontWeight: "bold",
                color: "#374151",
              }}
            >
              Stack trace (solo in development)
            </summary>
            <pre
              style={{
                background: "#f3f4f6",
                padding: "16px",
                overflow: "auto",
                fontSize: "12px",
                borderRadius: "8px",
                marginTop: "8px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {error.stack}
            </pre>
          </details>
        )}
        <button
          onClick={reset}
          style={{
            marginTop: "16px",
            padding: "12px 24px",
            backgroundColor: "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          Riprova
        </button>
      </body>
    </html>
  );
}
